// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/rsuite/dist/rsuite.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  line-height: normal;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
  "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Roboto", sans-serif !important;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
.dhiwise-code,
.dhiwise-navigation {
  min-height: 100%;
}
.fileUpload {
  display: none;
}
.common-pointer {
  cursor: pointer;
}
.dhiwise-navigation {
  padding: 20px;
  background-color: #232323;
}
.dhiwise-navigation h1 {
  color: white;
}
.dhiwise-navigation .headline {
  font-size: 14px;
  margin-bottom: 10px;
  color: white;
}
.dhiwise-navigation ul {
  padding: 0;
}
.dhiwise-navigation ul li {
  list-style: none;
  margin-right: 20px;
  font-size: 16px;
  font-weight: bold;
}
.dhiwise-navigation a {
  color: #132cdc;
}
table {
  border-spacing: 0;
  width: 100%;
}
.common-select {
  z-index: 10000;
}
.react-datepicker-popper {
  z-index: 100000 !important;
}
.drawable-icon{
  position: absolute;
  margin: auto;
  z-index: 1000;
}
.input-wrap{
  position: relative;
}
option{
  color: #000;
}
.table-wrap{
  overflow: auto;
}
input:focus{
  outline:none;
}
.ReactModal__Body--open{
  overflow: hidden;
}
  .slider-indicator:first-child {
    margin-left: 0;
}

.slider-indicator:last-child {
margin-right: 0;
}

.rc-drawer-content-wrapper{
  width: 100% !important;
}
.rc-drawer-right .rc-drawer-content-wrapper{
  display: flex;
  justify-content: flex-end;
}
.rc-drawer-left .rc-drawer-content-wrapper{
  display: flex;
  justify-content: flex-start;
}
.ReactModal__Overlay{
  z-index: 1051;
}

ul li a{
  display: block;
}

.mobile-menu div{
  height: 1.5px;
  width: 20px;
  background-color: #000;
  margin:4px 0;
}
.mobile-menu {
  display: none;
  cursor: pointer;
}
.header-row{
  align-items:center;
  justify-content: space-between;
  display: flex;
}
@media only screen and (min-width: 200px) and (max-width: 550px)  {
  .mobile-menu {
    display: block;
  }
  .header-row{
    width: 100% !important;
  }
  .display-block{
    display: block;
  }
  .display-none{
    display: none;
  }
  .common-row-list > ul{
    padding-left: 10px;
    padding-right: 10px;
    flex-wrap: wrap;
  }
}
@media print-page {
  body {
    width: 210mm; /* A4 width */
    height: 297mm; /* A4 height */
    margin: 0; /* No margins */
  }
}


.menu-close-icon {
  position: absolute;
  right: 16px;
  top: 16px;
}
.menu-overlay{
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.7;
  position: fixed;
  left: 0px;
  top: 0px;
}
.close-line1{
  transform: translate(0, 6px) rotate(-45deg) skewX(0) skewY(0) scaleX(1) scaleY(1);
}
.close-line2{
  transform: translate(0, 0) rotate(45deg) skewX(0) skewY(0) scaleX(1) scaleY(1);
}
.common-row-list > ul{
  display: flex;
  flex-direction: row;
  list-style-type: none;
  flex-grow: 1;
}

.common-column-list > ul{
  display: flex;
  flex-direction: column;
  list-style-type: none;
}

.common-column-list li{
  width: 100%;
}

.desactive {
  pointer-events: none;
  color: #999; /* Grayed out text color */
  background-color: #eee; /* Grayed out background color */
  cursor: not-allowed; 
}

/* scroll */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background: transparent;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #6b6b6b;
  border-radius: 10px;
}

.signature-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.signature-canvas-border {
  border: 1px solid #6b6b6b; /* Bordure noire */
  padding: 10px; /* Espace autour du canvas */
  align-items: center;
}

.signature-canvas {
  /* style canva */
  align-items: center;
}

.signature-button-delete {
  display: inline-block;
    position: relative;
    margin: 10px 0;
    padding: 0 20px;
    text-align: center;
    text-decoration: none;
    font: bold 12px/25px Arial, sans-serif;
    color: #515151;
    background: #d3d3d3;
    text-shadow: 1px 1px 1px rgba(255,255,255, .22);
    border-radius: 5px;
    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);
    transition: all 0.15s ease;
}

.signature-button-download{
  display: inline-block;
    position: relative;
    margin: 10px;
    padding: 0 20px;
    text-align: center;
    text-decoration: none;
    font: bold 12px/25px Arial, sans-serif;
    color: #515151;
    background: #d3d3d3;
    text-shadow: 1px 1px 1px rgba(255,255,255, .22);
    border-radius: 5px;
    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);
    transition: all 0.15s ease;
}


.signature-button-confirm, .button-ajout-membre, .button-bleu {
  display: inline-block;
    position: relative;
    margin: 10px;
    padding: 0 20px;
    text-align: center;
    text-decoration: none;
    font: normal 12px/25px Arial, sans-serif;
    color: #fff;
    background: #135f76;
    text-shadow: 1px 1px 1px rgba(255,255,255, .22);
    border-radius: 5px;
    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);
    transition: all 0.15s ease;
}
.signature-button-confirm:hover {
  background-color:" #0056b3"; /* Couleur de fond du bouton au survol */
}

.custom-file-upload{
  display: inline-block;
    position: relative;
    margin: 7px;
    padding: 0 20px;
    text-align: center;
    text-decoration: none;
    font: normal 12px/25px Arial, sans-serif;
    color: #515151;
    background: #d3d3d3;
    text-shadow: 1px 1px 1px rgba(255,255,255, .22);
    border-radius: 5px;
    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);
    transition: all 0.15s ease;
}

.custom-file-upload-delete{
  display: inline-block;
    position: relative;
    margin: 7px;
    padding: 0 20px;
    text-align: center;
    text-decoration: none;
    font: normal 12px/17px Arial, sans-serif;
    color: #515151;
    background: #d3d3d3;
    text-shadow: 1px 1px 1px rgba(255,255,255, .22);
    border-radius: 5px;
    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);
    transition: all 0.15s ease;
}


.croquisCanvas {
  border: 1px solid black;
  width: 100%;
  min-height: 500px;
  background-color: #eee;
}

/* Styles for mobile view */
@media (max-width: 768px) {
  /* Styles for the mobile toggle button */
  .mobile-toggle {
    display: block;
    /* Add any additional styling for the toggle button */
  }

  /* Hide the sidebar by default on small screens */
  .sidebar {
    display: none;
  }

  /* Show the sidebar when it's toggled */
  .sidebar:not(.hidden)  {
    display: block;
  }
}

table {
  border-collapse: collapse;
  width: auto;

}
th,
td {
  border: 1px solid black;
  padding: 4px;
  width: auto;

}
tr:hover{
  background-color: rgb(205, 201, 201);
  max-height: 10px;
    overflow-y: auto;
}
.dark-green {
  background-color: #006400;
  /* ou toute autre valeur de couleur verte foncée */
  /* Ajoutez d'autres styles si nécessaire */
}

/*
.delete-filter {
  padding: 10px 0px;
  width: 11%;
  font-size: 12px;
  cursor: pointer;
  border:1px solid;
  border-color: #c9c9c9;
  background-color: #f3f1f1;
  font-weight: normal;
  }
  */
  .delete-filter {
    padding: 6px 0px;
    width: 9%;
    font-size: 12px;
    cursor: pointer;
    border: none;
    background-color: #f3f1f1;
    font-weight: normal;
  } 
  
.delete-filter:hover {
  padding: 6px 0px;
  background-color: #135f76;
  cursor: pointer;
  color:white;
  border-color: #135f76;
}

.more-filter {
  padding: 6px 0px;
  width: 9%;
  font-size: 12px;
  cursor: pointer;
  border: none;
  background-color: #135f7619;
  font-weight: normal;
} 

.more-filter:hover {
padding: 6px 0px;
background-color: #135f76;
cursor: pointer;
color:white;
border-color: #135f76;
}

.page {
  width: 21cm;
  min-height: 29cm;
  margin: auto;
  background: white;
}
.subpage {
  padding: 1cm;
  border: 5px red solid;
  height: 237mm;
  outline: 2cm #FFEAEA solid;
}

@page {
  size: A4;
  margin: 1.3cm;
}

.titreCF {
  background-color: #00b050;
  color: black;
  width: 100%;
  justify-items: center;
  margin: auto;
  padding: 10px;
  text-align: center;
  font-weight: bolder;
  font-size: large;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}
.cyan_900 {
  background-color: #135f76;
  color: #ffffff;
}
.ENCOURS {
background-color: #eebc74;
  color: #ffffff;
  
}

.carte {
  color: black;
  font-weight: bold;
  height: 100px;
  display: flex;
  width: 200px;
  background: rgb(216, 228, 227);
  background: radial-gradient(circle, rgba(216, 228, 227, 1) 0%, rgba(255, 255, 255, 1) 100%);  align-items: center;
  text-align: center;
  justify-items: center;
}

/* styles.css */
.PhoneInput input:focus {
  border-color: #dedde4 !important; /* Remplace la bordure bleue par une bordure grise */
  box-shadow: none; /* Retire le effet d'ombre qui peut être appliqué lors du focus */
}

.PhoneInput input {
  border-color: #dedde4 !important; /* Remplace la bordure bleue par une bordure grise */
  box-shadow: none; /* Retire le effet d'ombre qui peut être appliqué lors du focus */
}


button {
  transition: background-color 0.3s ease, color 0.3s ease;
}

button:hover {
  background-color: #368196;
  color: #ffffff !important;
}

.no-underline {
  text-decoration: none;
}

/* styles.css or a similar stylesheet */
.hover-text-white-important:hover {
  color: white !important;
}

`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE;qGACmG;EACnG,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE;aACW;AACb;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;EACE;IACE,cAAc;AAClB;;AAEA;AACA,eAAe;AACf;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY,EAAE,aAAa;IAC3B,aAAa,EAAE,cAAc;IAC7B,SAAS,EAAE,eAAe;EAC5B;AACF;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,QAAQ;AACV;AACA;EACE,iFAAiF;AACnF;AACA;EACE,8EAA8E;AAChF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW,EAAE,0BAA0B;EACvC,sBAAsB,EAAE,gCAAgC;EACxD,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,aAAa,EAAE,4BAA4B;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,sCAAsC;IACtC,cAAc;IACd,mBAAmB;IACnB,+CAA+C;IAI/C,kBAAkB;IAIlB,kFAAkF;IAMlF,0BAA0B;AAC9B;;AAEA;EACE,qBAAqB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,sCAAsC;IACtC,cAAc;IACd,mBAAmB;IACnB,+CAA+C;IAI/C,kBAAkB;IAIlB,kFAAkF;IAMlF,0BAA0B;AAC9B;;;AAGA;EACE,qBAAqB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wCAAwC;IACxC,WAAW;IACX,mBAAmB;IACnB,+CAA+C;IAI/C,kBAAkB;IAIlB,kFAAkF;IAMlF,0BAA0B;AAC9B;AACA;EACE,2BAA2B,EAAE,wCAAwC;AACvE;;AAEA;EACE,qBAAqB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wCAAwC;IACxC,cAAc;IACd,mBAAmB;IACnB,+CAA+C;IAI/C,kBAAkB;IAIlB,kFAAkF;IAMlF,0BAA0B;AAC9B;;AAEA;EACE,qBAAqB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wCAAwC;IACxC,cAAc;IACd,mBAAmB;IACnB,+CAA+C;IAI/C,kBAAkB;IAIlB,kFAAkF;IAMlF,0BAA0B;AAC9B;;;AAGA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,wCAAwC;EACxC;IACE,cAAc;IACd,qDAAqD;EACvD;;EAEA,iDAAiD;EACjD;IACE,aAAa;EACf;;EAEA,uCAAuC;EACvC;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;;AAEb;AACA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,WAAW;;AAEb;AACA;EACE,oCAAoC;EACpC,gBAAgB;IACd,gBAAgB;AACpB;AACA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;;;;;;;;;;;GAWG;EACD;IACE,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;EACrB;;AAEF;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;AACA,gBAAgB;AAChB,yBAAyB;AACzB,eAAe;AACf,WAAW;AACX,qBAAqB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6EAA6E;AAC/E;AAGA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;AACA,yBAAyB;EACvB,cAAc;;AAEhB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,2FAA2F,GAAG,mBAAmB;EACjH,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,gCAAgC,EAAE,oDAAoD;EACtF,gBAAgB,EAAE,iEAAiE;AACrF;;AAEA;EACE,gCAAgC,EAAE,oDAAoD;EACtF,gBAAgB,EAAE,iEAAiE;AACrF;;;AAGA;EACE,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;AACzB","sourcesContent":["* {\n  box-sizing: border-box;\n  line-height: normal;\n}\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n  \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", \"Roboto\", sans-serif !important;\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n.dhiwise-code,\n.dhiwise-navigation {\n  min-height: 100%;\n}\n.fileUpload {\n  display: none;\n}\n.common-pointer {\n  cursor: pointer;\n}\n.dhiwise-navigation {\n  padding: 20px;\n  background-color: #232323;\n}\n.dhiwise-navigation h1 {\n  color: white;\n}\n.dhiwise-navigation .headline {\n  font-size: 14px;\n  margin-bottom: 10px;\n  color: white;\n}\n.dhiwise-navigation ul {\n  padding: 0;\n}\n.dhiwise-navigation ul li {\n  list-style: none;\n  margin-right: 20px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.dhiwise-navigation a {\n  color: #132cdc;\n}\ntable {\n  border-spacing: 0;\n  width: 100%;\n}\n.common-select {\n  z-index: 10000;\n}\n.react-datepicker-popper {\n  z-index: 100000 !important;\n}\n.drawable-icon{\n  position: absolute;\n  margin: auto;\n  z-index: 1000;\n}\n.input-wrap{\n  position: relative;\n}\noption{\n  color: #000;\n}\n.table-wrap{\n  overflow: auto;\n}\ninput:focus{\n  outline:none;\n}\n.ReactModal__Body--open{\n  overflow: hidden;\n}\n  .slider-indicator:first-child {\n    margin-left: 0;\n}\n\n.slider-indicator:last-child {\nmargin-right: 0;\n}\n\n.rc-drawer-content-wrapper{\n  width: 100% !important;\n}\n.rc-drawer-right .rc-drawer-content-wrapper{\n  display: flex;\n  justify-content: flex-end;\n}\n.rc-drawer-left .rc-drawer-content-wrapper{\n  display: flex;\n  justify-content: flex-start;\n}\n.ReactModal__Overlay{\n  z-index: 1051;\n}\n\nul li a{\n  display: block;\n}\n\n.mobile-menu div{\n  height: 1.5px;\n  width: 20px;\n  background-color: #000;\n  margin:4px 0;\n}\n.mobile-menu {\n  display: none;\n  cursor: pointer;\n}\n.header-row{\n  align-items:center;\n  justify-content: space-between;\n  display: flex;\n}\n@media only screen and (min-width: 200px) and (max-width: 550px)  {\n  .mobile-menu {\n    display: block;\n  }\n  .header-row{\n    width: 100% !important;\n  }\n  .display-block{\n    display: block;\n  }\n  .display-none{\n    display: none;\n  }\n  .common-row-list > ul{\n    padding-left: 10px;\n    padding-right: 10px;\n    flex-wrap: wrap;\n  }\n}\n@media print-page {\n  body {\n    width: 210mm; /* A4 width */\n    height: 297mm; /* A4 height */\n    margin: 0; /* No margins */\n  }\n}\n\n\n.menu-close-icon {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n}\n.menu-overlay{\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  opacity: 0.7;\n  position: fixed;\n  left: 0px;\n  top: 0px;\n}\n.close-line1{\n  transform: translate(0, 6px) rotate(-45deg) skewX(0) skewY(0) scaleX(1) scaleY(1);\n}\n.close-line2{\n  transform: translate(0, 0) rotate(45deg) skewX(0) skewY(0) scaleX(1) scaleY(1);\n}\n.common-row-list > ul{\n  display: flex;\n  flex-direction: row;\n  list-style-type: none;\n  flex-grow: 1;\n}\n\n.common-column-list > ul{\n  display: flex;\n  flex-direction: column;\n  list-style-type: none;\n}\n\n.common-column-list li{\n  width: 100%;\n}\n\n.desactive {\n  pointer-events: none;\n  color: #999; /* Grayed out text color */\n  background-color: #eee; /* Grayed out background color */\n  cursor: not-allowed; \n}\n\n/* scroll */\n::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n  background: transparent;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #6b6b6b;\n  border-radius: 10px;\n}\n\n.signature-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.signature-canvas-border {\n  border: 1px solid #6b6b6b; /* Bordure noire */\n  padding: 10px; /* Espace autour du canvas */\n  align-items: center;\n}\n\n.signature-canvas {\n  /* style canva */\n  align-items: center;\n}\n\n.signature-button-delete {\n  display: inline-block;\n    position: relative;\n    margin: 10px 0;\n    padding: 0 20px;\n    text-align: center;\n    text-decoration: none;\n    font: bold 12px/25px Arial, sans-serif;\n    color: #515151;\n    background: #d3d3d3;\n    text-shadow: 1px 1px 1px rgba(255,255,255, .22);\n \n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    border-radius: 5px;\n \n    -webkit-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    -moz-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n \n    -webkit-transition: all 0.15s ease;\n    -moz-transition: all 0.15s ease;\n    -o-transition: all 0.15s ease;\n    -ms-transition: all 0.15s ease;\n    transition: all 0.15s ease;\n}\n\n.signature-button-download{\n  display: inline-block;\n    position: relative;\n    margin: 10px;\n    padding: 0 20px;\n    text-align: center;\n    text-decoration: none;\n    font: bold 12px/25px Arial, sans-serif;\n    color: #515151;\n    background: #d3d3d3;\n    text-shadow: 1px 1px 1px rgba(255,255,255, .22);\n \n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    border-radius: 5px;\n \n    -webkit-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    -moz-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n \n    -webkit-transition: all 0.15s ease;\n    -moz-transition: all 0.15s ease;\n    -o-transition: all 0.15s ease;\n    -ms-transition: all 0.15s ease;\n    transition: all 0.15s ease;\n}\n\n\n.signature-button-confirm, .button-ajout-membre, .button-bleu {\n  display: inline-block;\n    position: relative;\n    margin: 10px;\n    padding: 0 20px;\n    text-align: center;\n    text-decoration: none;\n    font: normal 12px/25px Arial, sans-serif;\n    color: #fff;\n    background: #135f76;\n    text-shadow: 1px 1px 1px rgba(255,255,255, .22);\n \n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    border-radius: 5px;\n \n    -webkit-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    -moz-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n \n    -webkit-transition: all 0.15s ease;\n    -moz-transition: all 0.15s ease;\n    -o-transition: all 0.15s ease;\n    -ms-transition: all 0.15s ease;\n    transition: all 0.15s ease;\n}\n.signature-button-confirm:hover {\n  background-color:\" #0056b3\"; /* Couleur de fond du bouton au survol */\n}\n\n.custom-file-upload{\n  display: inline-block;\n    position: relative;\n    margin: 7px;\n    padding: 0 20px;\n    text-align: center;\n    text-decoration: none;\n    font: normal 12px/25px Arial, sans-serif;\n    color: #515151;\n    background: #d3d3d3;\n    text-shadow: 1px 1px 1px rgba(255,255,255, .22);\n \n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    border-radius: 5px;\n \n    -webkit-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    -moz-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n \n    -webkit-transition: all 0.15s ease;\n    -moz-transition: all 0.15s ease;\n    -o-transition: all 0.15s ease;\n    -ms-transition: all 0.15s ease;\n    transition: all 0.15s ease;\n}\n\n.custom-file-upload-delete{\n  display: inline-block;\n    position: relative;\n    margin: 7px;\n    padding: 0 20px;\n    text-align: center;\n    text-decoration: none;\n    font: normal 12px/17px Arial, sans-serif;\n    color: #515151;\n    background: #d3d3d3;\n    text-shadow: 1px 1px 1px rgba(255,255,255, .22);\n \n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    border-radius: 5px;\n \n    -webkit-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    -moz-box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n    box-shadow: 1px 1px 1px rgba(0,0,0, .29), inset 1px 1px 1px rgba(255,255,255, .44);\n \n    -webkit-transition: all 0.15s ease;\n    -moz-transition: all 0.15s ease;\n    -o-transition: all 0.15s ease;\n    -ms-transition: all 0.15s ease;\n    transition: all 0.15s ease;\n}\n\n\n.croquisCanvas {\n  border: 1px solid black;\n  width: 100%;\n  min-height: 500px;\n  background-color: #eee;\n}\n\n/* Styles for mobile view */\n@media (max-width: 768px) {\n  /* Styles for the mobile toggle button */\n  .mobile-toggle {\n    display: block;\n    /* Add any additional styling for the toggle button */\n  }\n\n  /* Hide the sidebar by default on small screens */\n  .sidebar {\n    display: none;\n  }\n\n  /* Show the sidebar when it's toggled */\n  .sidebar:not(.hidden)  {\n    display: block;\n  }\n}\n\ntable {\n  border-collapse: collapse;\n  width: auto;\n\n}\nth,\ntd {\n  border: 1px solid black;\n  padding: 4px;\n  width: auto;\n\n}\ntr:hover{\n  background-color: rgb(205, 201, 201);\n  max-height: 10px;\n    overflow-y: auto;\n}\n.dark-green {\n  background-color: #006400;\n  /* ou toute autre valeur de couleur verte foncée */\n  /* Ajoutez d'autres styles si nécessaire */\n}\n\n/*\n.delete-filter {\n  padding: 10px 0px;\n  width: 11%;\n  font-size: 12px;\n  cursor: pointer;\n  border:1px solid;\n  border-color: #c9c9c9;\n  background-color: #f3f1f1;\n  font-weight: normal;\n  }\n  */\n  .delete-filter {\n    padding: 6px 0px;\n    width: 9%;\n    font-size: 12px;\n    cursor: pointer;\n    border: none;\n    background-color: #f3f1f1;\n    font-weight: normal;\n  } \n  \n.delete-filter:hover {\n  padding: 6px 0px;\n  background-color: #135f76;\n  cursor: pointer;\n  color:white;\n  border-color: #135f76;\n}\n\n.more-filter {\n  padding: 6px 0px;\n  width: 9%;\n  font-size: 12px;\n  cursor: pointer;\n  border: none;\n  background-color: #135f7619;\n  font-weight: normal;\n} \n\n.more-filter:hover {\npadding: 6px 0px;\nbackground-color: #135f76;\ncursor: pointer;\ncolor:white;\nborder-color: #135f76;\n}\n\n.page {\n  width: 21cm;\n  min-height: 29cm;\n  margin: auto;\n  background: white;\n}\n.subpage {\n  padding: 1cm;\n  border: 5px red solid;\n  height: 237mm;\n  outline: 2cm #FFEAEA solid;\n}\n\n@page {\n  size: A4;\n  margin: 1.3cm;\n}\n\n.titreCF {\n  background-color: #00b050;\n  color: black;\n  width: 100%;\n  justify-items: center;\n  margin: auto;\n  padding: 10px;\n  text-align: center;\n  font-weight: bolder;\n  font-size: large;\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n}\n\n@import \"rsuite/dist/rsuite.css\";\n.cyan_900 {\n  background-color: #135f76;\n  color: #ffffff;\n}\n.ENCOURS {\nbackground-color: #eebc74;\n  color: #ffffff;\n  \n}\n\n.carte {\n  color: black;\n  font-weight: bold;\n  height: 100px;\n  display: flex;\n  width: 200px;\n  background: rgb(216, 228, 227);\n  background: radial-gradient(circle, rgba(216, 228, 227, 1) 0%, rgba(255, 255, 255, 1) 100%);  align-items: center;\n  text-align: center;\n  justify-items: center;\n}\n\n/* styles.css */\n.PhoneInput input:focus {\n  border-color: #dedde4 !important; /* Remplace la bordure bleue par une bordure grise */\n  box-shadow: none; /* Retire le effet d'ombre qui peut être appliqué lors du focus */\n}\n\n.PhoneInput input {\n  border-color: #dedde4 !important; /* Remplace la bordure bleue par une bordure grise */\n  box-shadow: none; /* Retire le effet d'ombre qui peut être appliqué lors du focus */\n}\n\n\nbutton {\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\nbutton:hover {\n  background-color: #368196;\n  color: #ffffff !important;\n}\n\n.no-underline {\n  text-decoration: none;\n}\n\n/* styles.css or a similar stylesheet */\n.hover-text-white-important:hover {\n  color: white !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
